var _excluded = ["invert", "size"];

var _templateObject;

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import React from "react";
import styled from "styled-components";
import { colorWhite } from "@nib-components/theme";
import { sizePropType } from "../../utils";
export var StyledPath = styled.path(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fill: ", "; /* colorBrandBase */\n"])), function (props) {
  return props.invert ? colorWhite : "#193B5C";
}); // small === min-height from brand guidelines

var sizes = {
  small: {
    width: "160.04px",
    height: "32px"
  },
  header: {
    width: "200.05px",
    height: "40px"
  },
  medium: {
    width: "240.06px",
    height: "48px"
  },
  large: {
    width: "320.08px",
    height: "64px"
  }
};

var NsiLogo = function NsiLogo(props) {
  var invert = props.invert,
      _props$size = props.size,
      size = _props$size === void 0 ? "small" : _props$size,
      otherProps = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 161 32",
    width: sizes[size].width,
    height: sizes[size].height,
    "aria-labelledby": "National Seniors Insurance",
    role: "img"
  }, otherProps), /*#__PURE__*/React.createElement(StyledPath, {
    invert: invert,
    d: "M116 25v.89h-2V32h-1v-6.11h-2V25h5ZM120 25c1.85 0 2.75.59 2.75 2a1.734 1.734 0 0 1-1.39 1.79L123 32h-1.11l-1.47-3h-1.55v3h-1v-7H120Zm-1.16 3.12H120c1.15 0 1.71-.34 1.71-1.13 0-.79-.53-1.14-1.69-1.14h-1.19l.01 2.27ZM127.84 25l2.16 7h-1l-.55-1.89h-2.54L125.3 32h-1l2.16-7h1.38Zm-1.74 4.26h2l-1-3.42h-.08l-.92 3.42ZM132 25l1.77 5.69 1.84-5.69h1l-2.27 7h-1.12L131 25h1ZM142.76 25v.87h-3.33v2h2.39v.86h-2.39v2.37h3.49v.9h-4.5v-7h4.34ZM145.9 25v6.1h3.1v.9h-4.12v-7h1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 25H0v7h107v-7ZM160 25h-7v7h7v-7Z",
    fill: "#69C9BF"
  }), /*#__PURE__*/React.createElement(StyledPath, {
    invert: invert,
    d: "M0 .19h3.63L8.82 9a30.313 30.313 0 0 1 2 4.2 22.665 22.665 0 0 1-.25-3.57V.19h3.15v17.54H10.6L5 8.69a31.189 31.189 0 0 1-2-4.22A22.79 22.79 0 0 1 3.15 8v9.7H0V.19ZM22.81 16.63a6.55 6.55 0 0 1-3.87 1.25 3.15 3.15 0 0 1-3.48-3.38c0-2.82 2.41-4.32 7.38-4.92v-1c0-.92-.65-1.45-1.84-1.45a3.41 3.41 0 0 0-2.86 1.45L16.05 7.3a5.59 5.59 0 0 1 5-2.46c3.05 0 4.77 1.42 4.77 3.74V16c.02.575.087 1.146.2 1.71h-2.94l-.27-1.08Zm-4.32-2.36a1.25 1.25 0 0 0 1.39 1.35 4.16 4.16 0 0 0 2.86-1.33v-2.7c-2.89.41-4.25 1.17-4.25 2.67v.01ZM33.14 15.42c.425-.003.85-.037 1.27-.1v2.46c-.844.156-1.701.23-2.56.22-2.14 0-3.05-.92-3.05-3V7.55h-1.69V5.09h1.69V1h3.08v4.05h2.53v2.46h-2.54v6.39c0 1.1.13 1.52 1.27 1.52ZM36.27.19h3.08V3h-3.08V.19Zm0 4.9h3.08v12.64h-3.08V5.09ZM46.37 4.85c3.48 0 5.56 2.41 5.56 6.56 0 4.15-2.11 6.59-5.56 6.59-3.45 0-5.56-2.44-5.56-6.56 0-4.12 2.09-6.59 5.56-6.59Zm0 10.57c1.66 0 2.46-1.33 2.46-4s-.79-4-2.46-4-2.46 1.3-2.46 4 .82 4 2.46 4ZM53.39 5.09h2.83v1.5a6.31 6.31 0 0 1 4-1.74c2.41 0 3.65 1.38 3.65 4.1v8.78h-3.05v-8.2c0-1.54-.37-2.24-1.49-2.24a4.4 4.4 0 0 0-2.88 1.4v9h-3.06V5.09ZM72.53 16.63a6.55 6.55 0 0 1-3.87 1.25 3.15 3.15 0 0 1-3.48-3.38c0-2.82 2.41-4.32 7.38-4.92v-1c0-.92-.65-1.45-1.84-1.45a3.41 3.41 0 0 0-2.86 1.45L65.77 7.3a5.59 5.59 0 0 1 5-2.46c3.05 0 4.77 1.42 4.77 3.74V16c.02.575.087 1.146.2 1.71H72.8l-.27-1.08Zm-4.32-2.36a1.25 1.25 0 0 0 1.39 1.35 4.16 4.16 0 0 0 2.86-1.33v-2.7c-2.89.41-4.25 1.17-4.25 2.67v.01ZM77.42.19h3.08v17.54h-3.08V.19ZM90.34 12.45c.94 1.86 2.06 2.68 3.68 2.68 1.84 0 2.93-.89 2.93-2.22s-.82-1.79-2.68-2.46A22.669 22.669 0 0 1 90 8.64a4.35 4.35 0 0 1-2.11-3.86C87.86 2 90.17 0 93.74 0c3.08 0 5.14 1.3 6.08 3.84l-3.08 1.09a3.34 3.34 0 0 0-3.25-2.24c-1.49 0-2.38.72-2.38 1.86 0 1.64 1.76 1.93 4.62 3.11 2.86 1.18 4.49 2.36 4.49 5.12 0 3.18-2.26 5.21-6.13 5.21-3.33 0-5.66-1.45-6.83-4.2l3.08-1.34ZM107 18c-3.45 0-5.51-2.39-5.51-6.54s2.09-6.59 5.46-6.59 5.39 2.32 5.39 6.42v.65h-7.8c0 2.39.94 3.59 2.76 3.59a3.001 3.001 0 0 0 2.66-1.62l2.26 1.35A5.519 5.519 0 0 1 107 18Zm2.31-8.2c0-1.69-.89-2.68-2.36-2.68-1.47 0-2.26 1-2.38 2.68h4.74ZM113.8 5.09h2.83v1.5a6.31 6.31 0 0 1 4-1.74c2.41 0 3.65 1.38 3.65 4.1v8.78h-3.08v-8.2c0-1.54-.37-2.24-1.49-2.24a4.4 4.4 0 0 0-2.88 1.4v9h-3.03V5.09ZM126 .19h3.08V3H126V.19Zm0 4.9h3.08v12.64H126V5.09ZM136.28 4.85c3.48 0 5.56 2.41 5.56 6.56 0 4.15-2.1 6.59-5.56 6.59-3.46 0-5.56-2.44-5.56-6.56 0-4.12 2.09-6.59 5.56-6.59Zm0 10.57c1.66 0 2.46-1.33 2.46-4s-.79-4-2.46-4-2.46 1.3-2.46 4 .83 4 2.46 4ZM143.46 5.09h2.93v2.1c.84-1.54 1.94-2.32 3.23-2.32a2.17 2.17 0 0 1 .4 0V8h-.15a3.71 3.71 0 0 0-3.28 2v7.75h-3.13V5.09ZM152.45 13.85a3.896 3.896 0 0 0 3 1.81c1.14 0 1.81-.55 1.81-1.4 0-1-.92-1.28-2.38-1.81-2.68-1-4.07-1.81-4.07-3.91s1.76-3.69 4.47-3.69a5.604 5.604 0 0 1 4.4 1.93l-1.94 1.64a3.521 3.521 0 0 0-2.53-1.28c-1.07 0-1.66.51-1.66 1.25s1.07 1.06 2.91 1.76c2.38.89 3.58 1.76 3.58 4S158.21 18 155.46 18a5.997 5.997 0 0 1-5.09-2.56l2.08-1.59Z"
  }));
};

NsiLogo.displayName = "NsiLogo";
NsiLogo.defaultProps = {
  invert: false,
  size: "small"
};
export default NsiLogo;